/** Width of the left TOC panel (px). All panels are this width. */
export const TOC_WIDTH= 450;
/** Width of the right comments / support panel (px). */
export const COMMENTS_WIDTH= 450;
